export default "__VITE_ASSET__bX83XmhL__"